import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { JhiItemCount, JhiPagination, Translate, getSortState } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Table } from 'reactstrap';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import DoNotShowInProduction from 'app/shared/components/do-not-show-in-production/do-not-show-in-production.component';
import { PageHeader } from 'app/shared/components/page-header/PageHeader';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ASC, DEFAULT_ITEMS_PER_PAGE, DESC, SORT } from 'app/shared/util/pagination.constants';
import { getEntities } from './sensor-hardware.reducer';

export const SensorHardware = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, DEFAULT_ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  const sensorHardwareList = useAppSelector(state => state.sensorHardware.entities);
  const loading = useAppSelector(state => state.sensorHardware.loading);
  const totalItems = useAppSelector(state => state.sensorHardware.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.replace(`${props.location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [props.location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const { match } = props;

  return (
    <div>
      <PageHeader
        headingId="sensor-hardware-heading"
        headingDataCy="SensorHardwareHeading"
        contentKey="fleetSenseApp.sensorHardware.home.title"
        buttonTextKey="fleetSenseApp.sensorHardware.home.createLabel"
        match={match}
      />
      <div className="table-responsive">
        {typeof sensorHardwareList === 'object' && sensorHardwareList && sensorHardwareList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <DoNotShowInProduction>
                  <th className="hand" onClick={sort('id')}>
                    <Translate contentKey="fleetSenseApp.sensorHardware.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                  </th>
                </DoNotShowInProduction>
                {/* <th className="hand" onClick={sort('manufacturer')}>
                  <Translate contentKey="fleetSenseApp.sensorHardware.manufacturer">Manufacturer</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('model')}>
                  <Translate contentKey="fleetSenseApp.sensorHardware.model">Model</Translate> <FontAwesomeIcon icon="sort" />
                </th> */}
                <th className="hand" onClick={sort('description')}>
                  <Translate contentKey="fleetSenseApp.sensorHardware.description">Description</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('equation')}>
                  <Translate contentKey="fleetSenseApp.sensorHardware.equation">Equation</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {sensorHardwareList.map((sensorHardware, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <DoNotShowInProduction>
                    <td>
                      <Button tag={Link} to={`${match.url}/${sensorHardware.id}`} color="link" size="sm">
                        {sensorHardware.id}
                      </Button>
                    </td>
                  </DoNotShowInProduction>
                  {/* <td>{sensorHardware.manufacturer}</td>
                  <td>{sensorHardware.model}</td> */}
                  <td>{sensorHardware.description}</td>
                  <td>{sensorHardware.equation}</td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      {/* <Button tag={Link} to={`${match.url}/${sensorHardware.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button> */}
                      <Button
                        tag={Link}
                        to={`${match.url}/${sensorHardware.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${sensorHardware.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="fleetSenseApp.sensorHardware.home.notFound">No Sensor Hardwares found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={sensorHardwareList && sensorHardwareList.length > 0 ? '' : 'd-none'}>
          <Row className="justify-content-center">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </Row>
          <Row className="justify-content-center">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </Row>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default SensorHardware;
